import { http } from "../httpHandler";
import { links } from "@/constants";
import { TServerErrorResponse } from "@/types";

export const connectConquest = async (data: {
  accessToken: string;
  refreshToken: string;
  expiresIn?: number;
}) => {
  try {
    const response = await http.post(links.conquest.connect, { ...data });
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
